function WcagFinder() {
    this.init();
}

WcagFinder.prototype.init = function(){
    var self = this;
    this.handleTableFirstColTdCheck();
	this.handleBannerHeaders();
};

function copyAttrs(copy, toCopy) {
    if(copy.attr('class')) {
        toCopy.attr("class", copy.attr("class"));
    }
    if(copy.attr("style")) {
        toCopy.attr("style", copy.attr("style"));
    }
}

function copyElem(elem, tag, addedClass) {
	var content = elem.html();
	var item = tag;
	if(addedClass) {
		item.addClass(addedClass);
	}
	item.html(content);

	copyAttrs(elem, item);
	elem.replaceWith(item);
}

WcagFinder.prototype.handleTableFirstColTdCheck = function () {
	$('.page-container table').each(function() {
		var tds = $(this).find('tr:first-of-type > td');
		var replace = false;
		var count = 0;

		tds.each(function() {
			if($(this).find('strong').length) {
				count++;
			}
		});

		replace = count == tds.length;

		if(replace) {
			tds.each(function() {
				var th = $("<th></th>");
				copyElem($(this), th);
			});
		}
	});
};

// WcagFinder.prototype.handleHeadingInTexts = function(){
//     $('.page-container section.-text h4').each(function() {
//         var item = $("<p></p>");
// 		copyElem($(this), item, 'h4');
//     });
// };

WcagFinder.prototype.handleBannerHeaders = function() {
	var $isBanner = $('.banners-slider-container');
	var $header = $('.page-container .profile-header h2');

	if($header.length && $isBanner.length) {
		$header.each(function() {
			var heading = $("<h1></h1>");
			copyElem($(this), heading, 'h2');
		});
		$('.banner.section-narrow').each(function() {
			$(this).find('.banner-item h1').each(function() {
				var item = $("<p></p>");
				copyElem($(this), item, 'h1');
			});
		});
	}
};